import React from 'react';
import styles from './css/SourceGroup.styl';
import {gaClickHandler} from '../../../../shared/utilities/GAHelpers';
import {buildUrl} from '../../../../shared/utilities/urlHelpers';
import _ from 'lodash';
import appConfig from '../../../../../appConfig/AppConfig';

const conf = appConfig();

/**
 * Determines font size based on description length
 * @method getFontSize
 * @param  {String} description The affilate or funeral home name
 * @return {String} The font size for the description display.
 */
export function getFontSize(description) {
  const sizes = [
    {minChars: 70, fontSize: '0.875rem'},
    {minChars: 60, fontSize: '1rem'},
    {minChars: 40, fontSize: '1.125rem'},
    {minChars: 25, fontSize: '1.375rem'},
    {minChars: 0, fontSize: '1.5rem'},
  ];

  return _.find(sizes, size => _.size(description) >= size.minChars).fontSize;
}

/**
 * Attempts to get either the affiliate or funeral home logos
 * @method getLogoUrl
 * @param  {String}         affiliateLogo   The full url for the affiliate logo
 * @param  {String}         funeralHomeLogo The URI for the funeral home logo
 * @param  {Number|Boolean} showFuneralHome Funeral home sourceId if truthy otherwise false
 * @return {String}         The fully formed logo url
 */
export function getLogoUrl(affiliateLogo, funeralHomeLogo, showFuneralHome) {
  // this is a known bad image in UDB
  const funeralHome =
    !funeralHomeLogo || funeralHomeLogo === '/legacy/images/fhlogo/logo.gif'
      ? null
      : `${buildUrl(conf.environmentalUrl.cacheUrl, funeralHomeLogo)}`;

  const display = {
    funeralHome,
    affiliate: affiliateLogo || null,
  };

  return display[showFuneralHome ? 'funeralHome' : 'affiliate'];
}

/**
 * The services section of the services group on the person page
 * @param   {Object}  props - passed down props
 * @return  {JSX}     Returns the services group
 */
const SourceItem = props => {
  const {obit} = props;
  const {
    affiliate,
    funeralHome,
    funeralHomeId,
    href,
    readMoreText,
    showReadMore,
  } = obit || {};

  const showFuneralHome = funeralHomeId > 1 && _.get(funeralHome, 'sourceId');

  const description = showFuneralHome
    ? _.get(funeralHome, 'name')
    : _.get(affiliate, 'description');

  const readMore = readMoreText || 'Read More';

  const logo = getLogoUrl(
    _.get(affiliate, 'logo'),
    _.get(funeralHome, 'logo'),
    showFuneralHome
  );

  return _.isEmpty(obit) ? null : (
    <div>
      <a href={href} target="_blank">
        <div
          className={styles.imageHolder}
          data-ga-no-auto-tag="true"
          onClick={gaClickHandler(
            'bypage_person',
            'readmore_logoimage_click',
            obit
          )}
        >
          {logo ? (
            <img src={logo} />
          ) : (
            <span style={{fontSize: getFontSize(description)}}>
              {description}
            </span>
          )}
        </div>
        <p
          data-ga-no-auto-tag="true"
          onClick={gaClickHandler(
            'bypage_person',
            'readmore_logotext_click',
            obit
          )}
        >
          {logo && !showReadMore ? (
            <span>{description}</span>
          ) : (
            <span className={styles.noWrap}>{readMore} &rsaquo;</span>
          )}
        </p>
      </a>
    </div>
  );
};

SourceItem.propTypes = {
  obit: React.PropTypes.object,
};

export default SourceItem;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/SourceGroup/SourceItem.js